import { combineSlices, configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface LazyLoadedSlices {}

export const rootReducer =
  combineSlices().withLazyLoadedSlices<LazyLoadedSlices>();

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['booking'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// NOTE: persistStore() deliberately does NOT live here. Persisted slices
// must be injected into the root reducer before PERSIST/REHYDRATE are
// dispatched, or autoMergeLevel1 silently drops their persisted state
// (#3296). The persistor is created in ~app/persistor.ts, which imports
// the persisted slices first.
